import { useState } from 'react';

export default function SportsWellness() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const activities = [
    {
      title: 'Padel',
      icon: 'ri-ping-pong-line',
      description: 'Profesjonalne korty do padla z panoramicznymi widokami. Idealne na turnieje grupowe, zawody międzyfirmowe lub po prostu na grę z przyjaciółmi.',
      image: 'https://i.imgur.com/JTs7ZEW.jpg',
      color: 'from-blue-600 to-cyan-600'
    },
    {
      title: 'Tenis',
      icon: 'ri-basketball-line',
      description: 'Korty tenisowe w doskonałym stanie otoczone subtropikalnymi ogrodami. Idealne na lekcje prywatne, treningi grupowe lub mecze towarzyskie.',
      image: 'https://i.imgur.com/IwOHAim.jpg',
      color: 'from-green-600 to-emerald-600'
    },
    {
      title: 'Siłownia',
      icon: 'ri-run-line',
      description: 'W pełni wyposażona siłownia z najnowszymi maszynami kardio i siłowymi aby Twoi klienci mogli utrzymać swoją rutynę treningową.',
      image: 'https://i.imgur.com/xXUIJc0.jpg',
      color: 'from-orange-600 to-red-600'
    },
    {
      title: 'Yoga & Mindfulness',
      icon: 'ri-heart-pulse-line',
      description: 'Zajęcia jogi na świeżym powietrzu z widokiem na ocean i ogród. Zajęcia prowadzone dla wszystkich poziomów: od początkujących po zaawansowanych.',
      images: [
        'https://i.imgur.com/c7vdGR9.jpg',
        'https://i.imgur.com/xvMhTYI.jpg'
      ],
      color: 'from-purple-600 to-pink-600'
    }
  ];

  const allImages = [
    { url: 'https://i.imgur.com/JTs7ZEW.jpg', alt: 'Korty do padla' },
    { url: 'https://i.imgur.com/IwOHAim.jpg', alt: 'Kort tenisowy' },
    { url: 'https://i.imgur.com/xXUIJc0.jpg', alt: 'Siłownia' },
    { url: 'https://i.imgur.com/c7vdGR9.jpg', alt: 'Joga widok 1' },
    { url: 'https://i.imgur.com/xvMhTYI.jpg', alt: 'Joga widok 2' }
  ];

  return (
    <>
      <section id="deportes" className="py-32 px-6 bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-200/20 rounded-full blur-3xl -z-10"></div>
        
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block mb-6">
              <div className="flex items-center gap-3 bg-gradient-to-r from-blue-700 to-cyan-700 text-white px-6 py-2 rounded-full">
                <i className="ri-heart-pulse-line text-2xl"></i>
                <span className="text-sm font-medium uppercase tracking-wider">Sport & Wellness</span>
              </div>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-light text-stone-800 mb-6 leading-tight">
              Znacznie więcej niż Golf
            </h2>
            
            <div className="w-32 h-1 bg-gradient-to-r from-transparent via-blue-600 to-transparent mx-auto mb-8"></div>
            
            <p className="text-xl text-stone-600 max-w-4xl mx-auto leading-relaxed">
              Jardín Tecina oferuje kompleksowe doświadczenie sportowe dla wszystkich gustów i poziomów zaawansowania. 
              Od sportów rakietowych po jogę nad morzem, a także siłownię najnowszej generacji.
            </p>
          </div>

          {/* Activities Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {activities.map((activity, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 group">
                <div className="relative h-80 overflow-hidden">
                  {activity.images ? (
                    <div className="grid grid-cols-2 gap-0 h-full">
                      {activity.images.map((img, imgIndex) => (
                        <div 
                          key={imgIndex}
                          className="relative overflow-hidden cursor-pointer"
                          onClick={() => setSelectedImage(3 + imgIndex)}
                        >
                          <img 
                            src={img}
                            alt={`${activity.title} ${imgIndex + 1}`}
                            className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <div className="absolute bottom-4 left-4 text-white">
                              <i className="ri-zoom-in-line text-2xl"></i>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div 
                      className="relative h-full overflow-hidden cursor-pointer"
                      onClick={() => setSelectedImage(index)}
                    >
                      <img 
                        src={activity.image}
                        alt={activity.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-6 left-6 text-white">
                          <i className="ri-zoom-in-line text-3xl"></i>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Gradient overlay with icon */}
                  <div className={`absolute top-6 left-6 w-14 h-14 flex items-center justify-center bg-gradient-to-br ${activity.color} rounded-full shadow-lg`}>
                    <i className={`${activity.icon} text-white text-2xl`}></i>
                  </div>
                </div>
                
                <div className="p-8">
                  <h3 className="text-2xl font-semibold text-stone-800 mb-4">{activity.title}</h3>
                  <p className="text-stone-600 leading-relaxed">
                    {activity.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Benefits Section */}
          <div className="bg-gradient-to-r from-blue-700 to-cyan-700 rounded-2xl p-12 text-white shadow-2xl mb-16">
            <h3 className="text-3xl font-light mb-8 text-center">
              Korzyści dla Twoich klientów
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-calendar-check-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Dostępne przez cały rok</h5>
                  <p className="text-blue-100 leading-relaxed">
                    Idealny klimat La Gomery pozwala uprawiać sport na świeżym powietrzu przez 365 dni w roku.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-group-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Idealne dla grup</h5>
                  <p className="text-blue-100 leading-relaxed">
                    Organizuj turnieje padla, tenisa lub sesje jogi dla grup korporacyjnych i incentive.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Dla wszystkich poziomów</h5>
                  <p className="text-blue-100 leading-relaxed">
                    Od początkujących po ekspertów, każda aktywność jest dostosowana do różnych poziomów.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-medal-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Profesjonalni instruktorzy</h5>
                  <p className="text-blue-100 leading-relaxed">
                    Wykwalifikowani profesjonaliści dostępni na lekcje prywatne i grupowe we wszystkich dyscyplinach.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-landscape-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Unikalne otoczenie</h5>
                  <p className="text-blue-100 leading-relaxed">
                    Uprawiaj sport w otoczeniu subtropikalnych ogrodów z widokiem na ocean Atlantycki.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                  <i className="ri-trophy-line text-2xl"></i>
                </div>
                <div>
                  <h5 className="font-semibold mb-2 text-lg">Wydarzenia sportowe</h5>
                  <p className="text-blue-100 leading-relaxed">
                    Organizuj spersonalizowane turnieje i zawody z nagrodami i cateringiem w cenie.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* B2B Selling Points */}
          <div className="bg-white rounded-2xl p-10 shadow-xl border-2 border-blue-200">
            <div className="flex items-start gap-6">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                <i className="ri-briefcase-line text-blue-700 text-3xl"></i>
              </div>
              <div>
                <h4 className="text-2xl font-semibold text-stone-800 mb-4">
                  Dlaczego warto sprzedawać to doświadczenie sportowe?
                </h4>
                <div className="space-y-3 text-stone-600 leading-relaxed">
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Wartość dodana do pakietu:</strong> Przekształć pobyt plażowy w kompletne aktywne doświadczenie, które uzasadnia wyższą cenę</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Idealne dla incentive korporacyjnych:</strong> Połącz sportowy team building z relaksem w unikalnym otoczeniu</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Przewaga konkurencyjna:</strong> Niewiele obiektów na Wyspach Kanaryjskich oferuje tak wiele opcji sportowych w jednym miejscu</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-blue-600 text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Przyciąga nisze premium:</strong> Podróżników sportowych, wellness travelers i grupy szukające aktywnych doświadczeń</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          {/* Removed CTA button */}
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          
          <div className="max-w-6xl w-full">
            <img 
              src={allImages[selectedImage].url}
              alt={allImages[selectedImage].alt}
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Navigation arrows */}
          {selectedImage > 0 && (
            <button
              className="absolute left-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage - 1);
              }}
            >
              <i className="ri-arrow-left-line text-2xl"></i>
            </button>
          )}
          
          {selectedImage < allImages.length - 1 && (
            <button
              className="absolute right-6 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImage(selectedImage + 1);
              }}
            >
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>
          )}
        </div>
      )}
    </>
  );
}
